module.exports = __webpack_public_path__ + "img/path-2.a3fa14a4.svg";